import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, HtmlContent } from './ui';

const StyledContentBlocks = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  display: grid;
  gap: 25px;

  ${minBreakpointQuery.tiny`
    gap: 30px;
  `}

  ${minBreakpointQuery.small`
    gap: 35px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  `}

  ${minBreakpointQuery.medium`
    gap: 50px;
  `}

  ${minBreakpointQuery.large`
    gap: 60px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 70px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    gap: 80px;
  `}
`;

const ContentBlocks = ({ items }) => (
  <StyledContentBlocks>
    <Container>
      <StyledInner>
        {items.map(({ content }, id) => (
          <HtmlContent key={id} content={content} />
        ))}
      </StyledInner>
    </Container>
  </StyledContentBlocks>
);

export default ContentBlocks;
